
export const geofenceExit = 'geofenceExit'
export const geofenceEnter = 'geofenceEnter'
export const deviceOverspeed = 'deviceOverspeed'
export const ignitionOn = 'ignitionOn'
export const ignitionOff = 'ignitionOff'
export const deviceFuelDrop = 'deviceFuelDrop'
export const routeDeviation = 'routeDeviation'
export const driverChanged = 'driverChanged'
export const maintenance = 'maintenance'
export const inactivity = 'inactivity'
export const alarmSOS = 'sos'
export const alarmGPSAntennaCut = 'gpsAntennaCut'
export const alarmTow = 'tow'
export const alarmHighRpm = 'highRpm'
export const alarmHardAcceleration = 'hardAcceleration'
export const alarmHardBraking = 'hardBraking'
export const alarmHardCornering = 'hardCornering'
export const alarmPowerCut = 'powerCut'
export const alarmShock = 'shock'
export const alarmPowerOn = 'powerOn'
export const alarmTemperature = 'temperature'
export const alarmBreakdown = 'breakdown'
export const alarmDoor = 'door1'
export const alarmIdle = 'idle'
export const alarmUnidentifiedDriver = 'unidentifiedDriver'
export const alarmSensor = 'sensor'
export const alarmEngineOff = 'alarmEngineOff'
export const alarmEngineOn = 'alarmEngineOn'
export const alarmTripDistance = 'alarmTripDistance'
export const alarmWeeklyDriving = 'alarmWeeklyDriving'
export const alarmGeofenceAbsence = 'alarmGeofenceAbsence'
export const alarmNoFuelConsumption = 'alarmNoFuelConsumption'

// Camera ADAS (advanced driver-assistance) / DMS (driver monitoring system) alarms.
export const alarmCameraAdas = 'cameraAdas'
export const alarmCameraDms = 'cameraDms'

// One alarm per ADAS / DMS event type, so each can have its own alert.
export const adasAlarmTypes = [
  'adasForwardCollision',
  'adasLaneDeparture',
  'adasFollowingDistance',
  'adasPedestrianCollision',
  'adasFrequentLaneChange',
  'adasRoadSignOverrun',
  'adasObstacle'
]

export const dmsAlarmTypes = [
  'dmsFatigue',
  'dmsPhoneUse',
  'dmsSmoking',
  'dmsDistraction',
  'dmsDriverAbnormal',
  'dmsHandsOffWheel',
  'dmsDriverChange'
]

export const cameraAlarmTypes = [
  alarmCameraAdas,
  alarmCameraDms
].concat(adasAlarmTypes, dmsAlarmTypes)

export const unitAlarmTypes = [
  alarmSOS,
  alarmGPSAntennaCut,
  alarmTow,
  alarmHighRpm,
  alarmHardAcceleration,
  alarmHardBraking,
  alarmHardCornering,
  alarmPowerCut,
  alarmShock,
  alarmPowerOn,
  alarmBreakdown,
  alarmDoor,
  alarmTemperature
].concat(cameraAlarmTypes)

export const customAlarmTypes = [
  alarmSOS,
  alarmGPSAntennaCut,
  alarmTow,
  alarmHighRpm,
  alarmHardAcceleration,
  alarmHardBraking,
  alarmHardCornering,
  alarmPowerCut,
  alarmShock,
  alarmPowerOn,
  alarmBreakdown,
  alarmDoor,
  alarmTemperature,
  alarmUnidentifiedDriver,
  alarmIdle,
  alarmSensor,
  alarmEngineOn,
  alarmEngineOff,
  alarmTripDistance,
  alarmGeofenceAbsence,
  alarmNoFuelConsumption
].concat(cameraAlarmTypes)

export const traccarAlertTypes = [
  geofenceExit,
  geofenceEnter,
  deviceOverspeed,
  ignitionOn,
  ignitionOff,
  deviceFuelDrop,
  routeDeviation,
  driverChanged,
  maintenance,
  inactivity
]

export const alertTypes = traccarAlertTypes.concat(customAlarmTypes)

export const unidentifiedDriverAlarmComputedId = 40
export const idleAlarmComputedId = 53
export const digitalPortAlarmComputedId = 55
export const calibrateTemperatureComputedId = 63
export const towAlarmComputedId = 65
export const tripDistanceAlarmComputedId = 120
